/**
 * Funzioni API per le impostazioni dei Ticket (Admin — product-service).
 *
 * Endpoint:
 *   GET /api/products/admin/ticket-settings  → TicketSettings
 *   PUT /api/products/admin/ticket-settings  → TicketSettings (solo SYSTEM_CONFIGURATION)
 */
import { createServiceClient } from '../../api/client.js';

const productApi = createServiceClient('product');

/**
 * Parole minime della nota per il cliente: chiudendo un ticket manuale come "non impattato" la
 * nota deve avere almeno questo numero di parole (parole >= minimo).
 */
export interface TicketSettings {
  customerNoteMinWords: number;
  /** admin = salvato da /admin; default = 100. */
  source: 'admin' | 'default';
  defaultCustomerNoteMinWords: number;
  min: number;
  max: number;
  rule: string;
  updatedAt?: string;
  updatedBy?: string;
}

export function fetchTicketSettings(): Promise<TicketSettings> {
  return productApi<TicketSettings>('/admin/ticket-settings');
}

export function updateCustomerNoteMinWords(customerNoteMinWords: number): Promise<TicketSettings> {
  return productApi<TicketSettings>('/admin/ticket-settings', {
    method: 'PUT',
    body: { customerNoteMinWords },
  });
}
